<template>
  <SubMenu
    :items="routers"
    variant="horizontal"
    class="account-nav-menu mt-3 mb-6 d-flex justify-content-center battle-submenu"
  >
    <router-link
      slot-scope="{ item: { name, title, routeName } }"
      active-class="router-link-active-custom"
      :class="{ 'router-link-alias-active': isActiveLink(routeName) }"
      :to="{
        name: name,
        params: {
          ...account.params,
          ...$route.params,
        },
      }"
    >
      {{ $t(`_web_account-tab_${name}`, title) }}
    </router-link>
  </SubMenu>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { VANITY_PREFIX } from '@/constants/router';
import SubMenu from '@/components/common/SubMenu';

export default {
  name: 'NavMenu',
  components: { SubMenu },
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccount: 'account' }),
    ...mapGetters(['dynamicBattleModel']),

    routers() {
      return this.account.routers
        .filter(routerItem => {
          return (
            this.filterRoutes(routerItem) ||
            this.showMyOrgSettings(routerItem) ||
            this.showBattleSquad(routerItem) ||
            this.showBattleResults(routerItem) ||
            this.showTournamentTeam(routerItem) ||
            this.showMatches(routerItem)
          );
        })
        .map(item => ({
          ...item,
          name: this.account.vanityId
            ? `${VANITY_PREFIX}${item.name}`
            : item.name,
          routeName: item.name,
          disabled:
            typeof item.isDisabled === 'function'
              ? item.isDisabled(this.account)
              : item.isDisabled || item.disabled,
        }));
    },
  },
  methods: {
    isActiveLink(name) {
      return (
        (this.$route.name === this.$routerNames.ACCOUNT &&
          name === this.$routerNames.ACCOUNT) ||
        (this.$route.name === this.$routerNames.EDIT &&
          name === this.$routerNames.EDIT)
      );
    },
    filterRoutes(routerItem) {
      return (
        !routerItem.ifAccountIsMy &&
        !routerItem.ifSquadIsVisible &&
        !routerItem.ifResultIsVisible &&
        !routerItem.ifTeamIsVisible &&
        !routerItem.ifBattlesIsVisible
      );
    },
    showMyOrgSettings(routerItem) {
      return (
        routerItem.ifAccountIsMy && this.myAccount._id === this.account._id
      );
    },
    showTournamentTeam(routerItem) {
      return (
        routerItem.ifTeamIsVisible &&
        !(typeof routerItem.isDisabled === 'function'
          ? routerItem.isDisabled(this.account)
          : routerItem.isDisabled || routerItem.disabled)
      );
    },
    showMatches(routerItem) {
      return (
        routerItem.ifBattlesIsVisible &&
        !(typeof routerItem.isDisabled === 'function'
          ? routerItem.isDisabled(this.account)
          : routerItem.isDisabled || routerItem.disabled)
      );
    },
    showBattleSquad(routerItem) {
      return (
        routerItem.ifSquadIsVisible &&
        this.$lodash.get(this, 'dynamicBattleModel.isSquadVisible', true)
      );
    },
    showBattleResults(routerItem) {
      return (
        routerItem.ifResultIsVisible &&
        !this.$lodash.get(this, 'dynamicBattleModel.isTechWin', false) &&
        !this.$lodash.get(this, 'dynamicBattleModel.isTechLose', false) &&
        this.$lodash.get(this, 'dynamicBattleModel.isResultVisible', false)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
ul {
  border-radius: 7px !important;
  overflow: hidden !important;
}
</style>
<style lang="scss">
.account-nav-menu {
  &.sub-menu {
    li {
      text-align: center;
      width: 100%;
      border-radius: 0px !important;
      background-color: $new-bg-primary-faded-second !important;
      &.list-group__item-expander {
        flex: 0 0 0.25rem;
      }
      a {
        font-size: 0.875rem;
        line-height: 1.25rem;
        background: transparent !important;
        font-weight: 600;
        &.router-link-active,
        &.router-link-alias-active,
        &.router-link-exact-active {
          color: $ph-primary-text;
          background-color: $new-bg-disabled !important;
          border-radius: 7px;
          &:before {
            height: 0px !important;
            transition: background-color 0.3s ease-in;
            display: none !important;
          }
        }
      }
    }
    &.sticky {
      top: $header-height;
    }
  }
}
@media (max-width: 767px) {
  .battle-submenu {
    .list-group-item {
      min-width: unset;
    }
  }
}
</style>
